import { styled } from '@mui/material/styles'
import ButtonBase from '@mui/material/ButtonBase'
import { Colors } from '../../theme'

// Abajo a la izquierda: el menú "+" se abre hacia arriba por la derecha.
export const ControlsStack = styled('div')(() => ({
  position: 'absolute',
  left: 16,
  bottom: 'calc(124px + env(safe-area-inset-bottom))',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  zIndex: 1,
}))

export const ControlGroup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 14,
  overflow: 'hidden',
  background: Colors.WHITE,
  boxShadow: `0 8px 24px ${Colors.SHADOW_CARD}`,
}))

export const ControlButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  width: 48,
  height: 48,
  color: active ? Colors.GREEN_BACKGROUND : Colors.BG_START,
  background: active ? Colors.BG_START : Colors.TRANSPARENT,
  fontFamily: 'inherit',
  fontSize: '0.9rem',
  fontWeight: 800,
  transition: 'background-color 160ms ease-out',
  '& + &': {
    borderTop: `1px solid ${Colors.GRAY_SEPARATOR}`,
  },
  '@media (hover: hover)': {
    '&:hover': {
      background: active ? Colors.BG_END : Colors.GRAY_LIGHT,
    },
  },
  '&:active': {
    background: Colors.GRAY_BACKGROUND,
  },
  '&.Mui-focusVisible': {
    outline: `2px solid ${Colors.PRIMARY}`,
    outlineOffset: -2,
  },
  '&.Mui-disabled': {
    color: Colors.GRAY_INDICATOR,
  },
}))

export const RecenterImage = styled('img')(() => ({
  width: 36,
  height: 36,
  objectFit: 'contain',
}))
